import { axiosInstance } from './axios.service'
import { IResponse } from '../types/response.type'
import { HeatmapEndpoints } from '../types/endpoint.type'
import { IHeatmap, IHeatmapResponse, IHeatmapRequest, IPathResponse } from '../../shared/types/api/heatmap.type'

export const createHeatmap = async (params: IHeatmapRequest): Promise<IResponse<IHeatmapResponse>> => {
  try {
    const data = await axiosInstance.post(`${HeatmapEndpoints.CREATE_HEATMAP}`, params)

    return {
      success: true,
      data: data.data,
      message: 'OK',
    }
  } catch (err: any) {
    return {
      success: false,
      message: err?.response?.data?.message ?? err.message,
    }
  }
}

export const getHeatmap = async (id: number, format: 'kml' | 'kmz'): Promise<Blob> => {
  const resp = await axiosInstance.get(`/rf-model/heatmap/${id}.${format}`, { responseType: 'blob' })
  return await resp.data
}

export const createHeatmapSimulation = async (params: IHeatmapRequest): Promise<IResponse<IHeatmap>> => {
  try {
    const data = await axiosInstance.post(`${HeatmapEndpoints.CREATE_SIMULATION}`, params)

    return {
      success: true,
      data: data.data,
      message: 'OK',
    }
  } catch (err: any) {
    return {
      success: false,
      message: err?.response?.data?.message ?? err.message,
    }
  }
}

export const analyzePoints = async (params: IHeatmapRequest): Promise<IResponse<IPathResponse>> => {
  try {
    const data = await axiosInstance.post(`${HeatmapEndpoints.ANALYZE_POINTS}`, params)

    return {
      success: true,
      data: data.data,
      message: 'OK',
    }
  } catch (err: any) {
    return {
      success: false,
      message: err?.response?.data?.message ?? err.message,
    }
  }
}
